import React from "react";
import { formatAngka } from "../../utils";

const DIMENSI = [
  { id: "program", name: "Program" },
  { id: "machine", name: "Mesin" },
  { id: "operator", name: "Operator" },
  { id: "service", name: "Jenis Layanan" },
  { id: "workshop", name: "Workshop" },
];

function PanelDrilldown({ by, onChangeBy, data }) {
  const baris = data?.data || [];

  return (
    <div>
      <div className="d-flex align-items-center mb-2" style={{ fontSize: "12px" }}>
        <span className="me-2 fw-bold">Lihat berdasarkan</span>
        <select
          className="form-select form-select-sm"
          style={{ width: 200, fontSize: "12px" }}
          value={by}
          onChange={(e) => onChangeBy(e.target.value)}
        >
          {DIMENSI.map((val) => (
            <option key={val.id} value={val.id}>
              {val.name}
            </option>
          ))}
        </select>
      </div>

      <div className="table-responsive">
        <table
          className="table table-bordered align-middle mb-0"
          style={{ fontSize: "12px" }}
        >
          <thead className="table-light">
            <tr>
              <th>Referensi</th>
              <th>Indikator</th>
              <th className="text-end">Total</th>
              <th className="text-end">Intensitas</th>
              <th className="text-end">Dihemat</th>
              <th className="text-end">Order</th>
              <th className="text-end">Volume (kg)</th>
            </tr>
          </thead>
          <tbody>
            {baris.length > 0 ? (
              baris.map((val, i) => (
                <tr key={`${val.scope}-${val.indicator_code}-${i}`}>
                  <td>
                    {val.ref || "-"}
                    <div className="text-muted" style={{ fontSize: "10px" }}>
                      {val.scope}
                    </div>
                  </td>
                  <td>{val.indicator_code}</td>
                  <td className="text-end">{formatAngka(val.total)}</td>
                  <td className="text-end">{formatAngka(val.intensity, 4)}</td>
                  <td className="text-end">{formatAngka(val.total_saved)}</td>
                  <td className="text-end">{formatAngka(val.order_count, 0)}</td>
                  <td className="text-end">
                    {formatAngka(val.total_weight_kg, 1)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} align="center">
                  Data tidak ditemukan
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PanelDrilldown;
